module.exports = __webpack_public_path__ + "img/banderita.2f97248d.png";